import React, { useState, lazy } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, CarIcon, PenToolIcon, ShieldIcon, ZapIcon } from 'lucide-react';
export const PortfolioSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const projects = [{
    title: 'BMW 3-Series Premium Finish',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/epTaMYxL4anUJLdbRfE6sf/Afbeelding-van-WhatsApp-op-2024-09-11-om-03.56.27_c7bf755e.jpg',
    description: 'Elegante rode BMW met zwarte accenten en premium afwerking in onze professionele studio.',
    features: ['Sportieve uitstraling', 'Zwarte accenten', 'Glanzende afwerking'],
    type: 'Premium Car Styling'
  }, {
    title: 'Mercedes-Benz Vito Black Edition',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2BmxpFXUm1C8xaNUxk17xV/Afbeelding-van-WhatsApp-op-2024-09-12-om-10.45.40_b41d2ffd.jpg',
    description: 'Mercedes bedrijfsvoertuig met custom zwarte grille en bumper voor een stoere, professionele uitstraling.',
    features: ['Chrome delete', 'Zwarte accenten', 'Professionele uitstraling'],
    type: 'Bedrijfswagen Styling'
  }, {
    title: 'Volkswagen Golf R Signature Blue',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bV7uXCz26reNCSdJt3r47x/Afbeelding-van-WhatsApp-op-2024-09-12-om-10.45.41_5602992b.jpg',
    description: 'Sportieve VW Golf in opvallend blauw met zwarte grille en bumper voor een krachtige look.',
    features: ['Sportieve styling', 'Zwarte details', 'Verlaagd profiel'],
    type: 'Sport Edition'
  }, {
    title: 'Mercedes-AMG Custom White',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3v8Pos7TXNGtqMbGvoXuvd/Afbeelding-van-WhatsApp-op-2024-09-12-om-10.45.41_fb59bef4.jpg',
    description: 'Exclusieve Mercedes-AMG in stralend wit met zwarte Panamericana grille en sportieve details.',
    features: ['Premium afwerking', 'Sportieve uitstraling', 'AMG styling'],
    type: 'Luxury Performance'
  }];
  const nextSlide = () => {
    setActiveIndex(prevIndex => (prevIndex + 1) % projects.length);
  };
  const prevSlide = () => {
    setActiveIndex(prevIndex => (prevIndex - 1 + projects.length) % projects.length);
  };
  const getFeatureIcon = (index: number) => {
    switch (index % 4) {
      case 0:
        return <CarIcon size={16} className="text-[#D6281F]" data-id="element-390" />;
      case 1:
        return <PenToolIcon size={16} className="text-[#D6281F]" data-id="element-391" />;
      case 2:
        return <ShieldIcon size={16} className="text-[#D6281F]" data-id="element-392" />;
      case 3:
        return <ZapIcon size={16} className="text-[#D6281F]" data-id="element-393" />;
    }
  };
  return <section id="portfolio" className="py-16 bg-[#0a0a0a]" data-id="element-394">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-395">
        <div className="text-center mb-10" data-id="element-396">
          <h2 className="text-3xl md:text-4xl font-bold mb-3" data-id="element-397">
            <span className="text-[#D6281F]" data-id="element-398">Recente</span>{' '}
            <span className="text-white" data-id="element-399">Projecten</span>
          </h2>
          <p className="text-[#CCCCCC] max-w-2xl mx-auto text-sm md:text-base" data-id="element-400">
            Ontdek onze meest recente transformaties uit onze premium studio.
          </p>
        </div>
        <div className="relative" data-id="element-401">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-402">
            {/* Left side: Current active image with aspect ratio container */}
            <div className="relative rounded-md overflow-hidden shadow-lg border border-white/10 group" data-id="element-403">
              <div className="relative" data-id="element-404">
                {/* Aspect ratio container */}
                <div className="relative w-full bg-[#121212]" style={{
                paddingBottom: '75%'
              }} data-id="element-405">
                  <img src={projects[activeIndex].imageUrl} alt={projects[activeIndex].title} className="absolute inset-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" decoding="async" data-id="element-406" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 group-hover:opacity-50 transition-opacity duration-300" data-id="element-407"></div>
                <div className="absolute top-3 right-3" data-id="element-408">
                  <div className="bg-black/70 backdrop-blur-sm px-2 py-1 rounded border border-white/10" data-id="element-409">
                    <span className="text-white/90 text-xs font-medium" data-id="element-410">
                      BKCustoms Studio
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* Right side: Project details */}
            <div className="flex flex-col justify-center" data-id="element-411">
              <div className="bg-[#121212] p-6 rounded-md border border-white/10 h-full" data-id="element-412">
                <div className="inline-flex items-center bg-[#D6281F]/10 px-2 py-1 rounded mb-4" data-id="element-413">
                  <span className="text-[#D6281F] text-xs font-medium" data-id="element-414">
                    {projects[activeIndex].type}
                  </span>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3" data-id="element-415">
                  {projects[activeIndex].title}
                </h3>
                <p className="text-[#CCCCCC] text-base mb-6" data-id="element-416">
                  {projects[activeIndex].description}
                </p>
                <div className="space-y-2 mb-6" data-id="element-417">
                  {projects[activeIndex].features.map((feature, idx) => <div key={idx} className="flex items-center" data-id="element-418">
                      {getFeatureIcon(idx)}
                      <span className="ml-2 text-white/80 text-sm" data-id="element-419">
                        {feature}
                      </span>
                    </div>)}
                </div>
                <div className="flex items-center justify-between" data-id="element-420">
                  <div className="flex space-x-1.5" data-id="element-421">
                    {projects.map((_, index) => <button key={index} onClick={() => setActiveIndex(index)} className={`w-2 h-2 rounded-full transition-all duration-200 ${index === activeIndex ? 'bg-[#D6281F]' : 'bg-[#333333] hover:bg-[#D6281F]/50'}`} aria-label={`Go to project ${index + 1}`} data-id="element-422" />)}
                  </div>
                  <div className="flex space-x-2" data-id="element-423">
                    <button onClick={prevSlide} className="bg-[#121212] border border-[#333333] hover:border-[#D6281F] text-white p-1.5 rounded transition-colors duration-200" aria-label="Previous project" data-id="element-424">
                      <ChevronLeftIcon size={18} data-id="element-425" />
                    </button>
                    <button onClick={nextSlide} className="bg-[#D6281F] text-white p-1.5 rounded transition-colors duration-200" aria-label="Next project" data-id="element-426">
                      <ChevronRightIcon size={18} data-id="element-427" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Thumbnail preview with aspect ratio containers */}
          <div className="hidden md:grid grid-cols-4 gap-3" data-id="element-428">
            {projects.map((project, index) => <div key={index} onClick={() => setActiveIndex(index)} className={`cursor-pointer rounded overflow-hidden border ${index === activeIndex ? 'border-[#D6281F]' : 'border-white/10 hover:border-white/30'} transition-colors duration-200`} data-id="element-429">
                <div className="relative w-full" style={{
              paddingBottom: '75%'
            }} data-id="element-430">
                  <img src={project.imageUrl} alt={project.title} className="absolute inset-0 w-full h-full object-cover object-center" decoding="async" data-id="element-431" />
                  <div className={`absolute inset-0 bg-black/50 ${index === activeIndex ? 'opacity-0' : 'opacity-70'} hover:opacity-30 transition-opacity duration-200`} data-id="element-432"></div>
                </div>
              </div>)}
          </div>
        </div>
        <div className="mt-8 text-center" data-id="element-433">
          <a href="#contact" className="inline-flex items-center text-white bg-[#121212] border border-[#333333] hover:border-[#D6281F] px-5 py-2 rounded transition-colors duration-200 text-sm" data-id="element-434">
            Vraag ons advies voor jouw auto
          </a>
        </div>
      </div>
    </section>;
};